import React from "react";
import { Card, Alert } from "react-bootstrap";

function VariablesOverview() {
  return (
    <div>
      <h2 className="mb-4">Variables Overview</h2>

      <Alert variant="info">
        Variables allow you to store reusable data that runbooks can access during execution.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>What are Variables?</h4>
          <p>
            Variables are data storage containers that hold information your runbooks can use. Instead of hardcoding
            values into your workflows, you can store them in variables and reference them by name.
          </p>
          <p className="mt-3">
            Variables are useful for:
          </p>
          <ul>
            <li>Storing configuration data</li>
            <li>Maintaining lookup tables</li>
            <li>Sharing data between runbooks</li>
            <li>Keeping frequently-changed values in one place</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Variable Structure</h4>
          <p>
            Each variable has:
          </p>
          <ul>
            <li><strong>Variable Name/ID</strong> - A unique identifier</li>
            <li><strong>Variable Lines</strong> - The actual data entries, each with a key and value</li>
          </ul>
          <p className="mt-3">
            Think of a variable as a table: the variable name is the table name, and variable lines are the rows of data.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Viewing Your Variables</h4>
          <ol>
            <li>Click <strong>My Variables</strong> in the left menu</li>
            <li>You'll see a grid of all variables</li>
            <li>Click on any variable to view its data entries (variable lines)</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Variable Lines (Data Entries)</h4>
          <p>
            Each variable can contain multiple key-value pairs called "variable lines":
          </p>
          <ul>
            <li><strong>Key</strong> - The identifier for this data entry</li>
            <li><strong>Value</strong> - The actual data</li>
          </ul>
          <p className="mt-3">
            For example, a variable named "EmailAddresses" might have lines like:
          </p>
          <ul>
            <li>Key: "support", Value: "support@company.com"</li>
            <li>Key: "sales", Value: "sales@company.com"</li>
            <li>Key: "admin", Value: "admin@company.com"</li>
          </ul>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Using Variables in Runbooks</h4>
          <p>
            When designing a workflow in the Workflow Builder, you can reference variables in step configurations.
            During execution, the runbook will read the current values from the variable.
          </p>
          <p className="mt-3">
            This means you can update variable data without modifying your runbooks!
          </p>
        </Card.Body>
      </Card>
    </div>
  );
}

export default VariablesOverview;
